<template>
  <el-button
    :disabled="disabled"
    round
    :loading="loading"
    :class="buttonClass"
    :icon="btnIcon"
    @click="click"
  >{{ buttonText }}</el-button>
</template>
<script>
import i18n from "../../lang";
export default {
  components: {},
  props: {
    type: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      btnBackGroudColor: {
        blue: "#029FE7",
        green: "#17A84E",
        yellow: "#ECAD26",
        purple: "#7260EC",
        red: "#EC4345",
        skyblue: "#029FE7"
      },
      btnBorderColor: {
        blue: "#029FE7",
        green: "#17A84E",
        yellow: "#ECAD26",
        purple: "#7260EC",
        red: "#EC4345",
        skyblue: "#029FE7"
      },
      btnTextColor: {
        blue: "#ffffff",
        green: "#ffffff",
        yellow: "#ffffff",
        purple: "#ffffff",
        red: "#ffffff",
        skyblue: "#029FE7"
      },
      commonType: {
        // 保存
        save: {
          color: "blue",
          text: "button.save",
          icon: "el-icon-ali-iconbaocun"
        },

        // 取消
        cancel: {
          color: "skyblue",
          text: "button.cancel",
          icon: "el-icon-ali-iconguanbi"
        },

        // 下载
        download: {
          color: "skyblue",
          text: "button.download",
          icon: "el-icon-download"
        },

        // 查看
        view: {
          color: "blue",
          text: "button.view",
          icon: "el-icon-ali-iconchakan"
        },

        // 编辑
        edit: {
          color: "blue",
          text: "button.edit",
          icon: "el-icon-ali-iconbianji"
        },

        // 生成
        generate: {
          color: "blue",
          text: "button.generate",
          icon: "el-icon-ali-baobiaotongji"
        },

        // 搜索
        search: {
          color: "blue",
          text: "button.search",
          icon: "el-icon-ali-sousuo"
        },

        // 提交
        submit: {
          color: "blue",
          text: "button.submit",
          icon: "el-icon-ali-submit"
        },

        // 重置
        reset: {
          color: "yellow",
          text: "button.reset",
          icon: "el-icon-ali-shuaxin"
        },

        // 新增
        add: {
          color: "blue",
          text: "button.add",
          icon: "el-icon-ali-iconxizneng"
        },

        // 导入
        import: {
          color: "blue",
          text: "button.import",
          icon: "el-icon-ali-iconshangchuan"
        },

        // 启用
        enable: {
          color: "blue",
          text: "button.enable",
          icon: "el-icon-ali-iconxuanze"
        },

        // 禁用
        disable: {
          color: "red",
          text: "button.disable",
          icon: "el-icon-ali-iconguanbi"
        },

        // 删除
        delete: {
          color: "red",
          text: "button.delete",
          icon: "el-icon-ali-iconshanchu"
        },

        //
        upload: {
          color: "blue",
          text: "button.upload",
          icon: "el-icon-ali-iconshangchuan"
        },

        // 返回
        return: {
          color: "skyblue",
          text: "button.return",
          icon: "el-icon-ali-iconguanbi"
        },

        // 撤销
        revoke: {
          color: "blue",
          text: "button.revoke",
          icon: "el-icon-ali-iconbaocun"
        },

        // 同步
        sync: {
          color: "blue",
          text: "button.sync",
          icon: "el-icon-ali-iconpeizhi"
        },

        // 增加节点
        addNode: {
          color: "blue",
          text: "button.addNode",
          icon: "el-icon-ali-iconxizneng"
        },

        // 增加子节点
        addChildNode: {
          color: "blue",
          text: "button.addChildNode",
          icon: "el-icon-ali-iconxizneng"
        },

        // 删除节点
        deleteNode: {
          color: "red",
          text: "button.deleteNode",
          icon: "el-icon-ali-iconshanchu"
        },

        // 删除文件
        deleteFile: {
          color: "red",
          text: "button.deleteFile",
          icon: "el-icon-ali-iconshanchu"
        },

        // 上传文件
        uploadFile: {
          color: "blue",
          text: "button.uploadFile",
          icon: "el-icon-ali-iconshangchuan"
        },

        // 分配
        assign: {
          color: "blue",
          text: "button.assign",
          icon: "el-icon-ali-iconbaocun"
        },

        // 发送
        send: {
          color: "blue",
          text: "button.send",
          icon: "el-icon-ali-send"
        },
        // 下一步
        next: {
          color: "blue",
          text: "button.next",
          icon: "el-icon-ali-xiayibu"
        },
        // 上一步
        previousStep: {
          color: "blue",
          text: "button.previousStep",
          icon: "el-icon-ali-shangyibu"
        },
        // 重新提交
        resubmit: {
          color: "blue",
          text: "button.resubmit",
          icon: "el-icon-ali-congxintijiao"
        },

        // 全选
        allSelect: {
          color: "blue",
          text: "button.allSelect",
          icon: "el-icon-ali-iconxuanze"
        },

        // 反选
        reverseSelect: {
          color: "blue",
          text: "button.reverseSelect",
          icon: "el-icon-ali-iconxuanze"
        },

        // 取消选择
        cancelSelect: {
          color: "skyblue",
          text: "button.cancelSelect",
          icon: "el-icon-ali-iconguanbi"
        },

        // 同意
        approve: {
          color: "blue",
          text: "button.approve",
          icon: "el-icon-ali-iconxuanze"
        },

        // 拒绝
        reject: {
          color: "skyblue",
          text: "button.reject",
          icon: "el-icon-ali-iconguanbi"
        },

        // 授权
        authorize: {
          color: "blue",
          text: "queryForm.authorized",
          icon: "el-icon-ali-iconbaocun"
        },
        // 更新日程
        updateSchedule: {
          color: "blue",
          text: "button.updateSchedule",
          icon: ""
        },
        //查看日程
        viewSchedule: {
          color: "blue",
          text: "button.viewSchedule",
          icon: ""
        },
        // 链接
        addLink: {
          color: "blue",
          text: "checkList.addLink",
          icon: "el-icon-ali-link"
        }
      },
      elType: ["primary", "success", "warning", "danger", "info", "text"],
      buttonStyle: {},
      buttonText: {},
      btnIcon: "",
      buttonClass: ""
    };
  },
  computed: {
    language() {
      return this.$store.state.app.language;
    }
  },
  watch: {
    text(newValue) {
      this.buttonText = i18n.t(newValue);
    },
    language(newVal, oldVal) {
      this.setButtonTxt();
    }
  },
  created() {
    this.setButtonTxt();
  },
  mounted() {},
  methods: {
    click() {
      this.$emit("click");
    },
    setButtonTxt() {
      if (this.type === "superQuery") {
        this.buttonClass = "el-button--superquery";
        this.buttonText = "高级检索";
      } else if (this.elType.indexOf(this.type) > -1) {
      } else {
        var set = this.commonType[this.type];
        if (set !== null || set !== undefined) {
          this.buttonClass = "el-button--" + set.color;
          // this.buttonStyle = {
          //   color: this.btnTextColor[set.color],
          //   backgroundColor: this.btnBackGroudColor[set.color],
          //   border: "1px solid " + this.btnBorderColor[set.color]
          // };
          this.btnIcon = set.icon;
          this.buttonText = i18n.t(set.text);
        }
      }
      if (this.text) {
        this.buttonText = i18n.t(set.text);
      }
      if (this.icon) {
        this.buttonClass = this.icon;
      }
    }
  }
};
</script>
<style scoped>
/* blue */
.el-button--blue {
  color: #fff;
  background-color: #228ae1;
  border-color: #228ae1;
}

.el-button--blue:hover {
  background: #4ea1e7 !important;
  border-color: #4ea1e7 !important;
  color: #fff !important;
}

.el-button--blue.is-active,
.el-button--blue:active {
  background: #1f7ccb !important;
  border-color: #1f7ccb !important;
  color: #fff !important;
}

.el-button--blue:active {
  outline: 0;
}

.el-button--blue.is-disabled,
.el-button--blue.is-disabled:active,
.el-button--blue.is-disabled:focus,
.el-button--blue.is-disabled:hover {
  color: #fff !important;
  background-color: #91c5f0 !important;
  border-color: #91c5f0 !important;
}

.el-button--blue.is-plain {
  color: #228ae1;
  background: #e9f3fc;
  border-color: #a7d0f3;
}

.el-button--blue.is-plain:focus,
.el-button--blue.is-plain:hover {
  background: #228ae1;
  border-color: #228ae1;
  color: #fff;
}

.el-button--blue.is-plain:active {
  background: #1f7ccb;
  border-color: #1f7ccb;
  color: #fff;
  outline: 0;
}

.el-button--blue.is-plain.is-disabled,
.el-button--blue.is-plain.is-disabled:active,
.el-button--blue.is-plain.is-disabled:focus,
.el-button--blue.is-plain.is-disabled:hover {
  color: #7ab9ed;
  background-color: #e9f3fc;
  border-color: #d3e8f9;
}

/* green */
.el-button--green {
  color: #fff;
  background-color: #17a84e;
  border-color: #17a84e;
}

.el-button--green:hover {
  background: #45b971 !important;
  border-color: #45b971 !important;
  color: #fff !important;
}

.el-button--green.is-active,
.el-button--green:active {
  background: #159746 !important;
  border-color: #159746 !important;
  color: #fff !important;
}

.el-button--green:active {
  outline: 0;
}

.el-button--green.is-disabled,
.el-button--green.is-disabled:active,
.el-button--green.is-disabled:focus,
.el-button--green.is-disabled:hover {
  color: #fff !important;
  background-color: #8bd4a7 !important;
  border-color: #8bd4a7 !important;
}

.el-button--green.is-plain {
  color: #17a84e;
  background: #e8f6ed;
  border-color: #a2dcb8;
}

.el-button--green.is-plain:focus,
.el-button--green.is-plain:hover {
  background: #17a84e;
  border-color: #17a84e;
  color: #fff;
}

.el-button--green.is-plain:active {
  background: #159746;
  border-color: #159746;
  color: #fff;
  outline: 0;
}

.el-button--green.is-plain.is-disabled,
.el-button--green.is-plain.is-disabled:active,
.el-button--green.is-plain.is-disabled:focus,
.el-button--green.is-plain.is-disabled:hover {
  color: #74cb95;
  background-color: #e8f6ed;
  border-color: #d1eedc;
}

/* yellow */
.el-button--yellow {
  color: #fff;
  background-color: #ecad26;
  border-color: #ecad26;
}

.el-button--yellow:hover {
  background: #f0bd51 !important;
  border-color: #f0bd51 !important;
  color: #fff;
}

.el-button--yellow.is-active,
.el-button--yellow:active {
  background: #d49c22 !important;
  border-color: #d49c22 !important;
  color: #fff;
}

.el-button--yellow:active {
  outline: 0;
}

.el-button--yellow.is-disabled,
.el-button--yellow.is-disabled:active,
.el-button--yellow.is-disabled:focus,
.el-button--yellow.is-disabled:hover {
  color: #fff !important;
  background-color: #f6d693 !important;
  border-color: #f6d693 !important;
}

.el-button--yellow.is-plain {
  color: #ecad26;
  background: #fdf7e9;
  border-color: #f7dea8;
}

.el-button--yellow.is-plain:focus,
.el-button--yellow.is-plain:hover {
  background: #ecad26;
  border-color: #ecad26;
  color: #fff;
}

.el-button--yellow.is-plain:active {
  background: #d49c22;
  border-color: #d49c22;
  color: #fff;
  outline: 0;
}

.el-button--yellow.is-plain.is-disabled,
.el-button--yellow.is-plain.is-disabled:active,
.el-button--yellow.is-plain.is-disabled:focus,
.el-button--yellow.is-plain.is-disabled:hover {
  color: #f4ce7d;
  background-color: #fdf7e9;
  border-color: #fbefd4;
}

/* purple */

.el-button--purple {
  color: #fff;
  background-color: #7260ec;
  border-color: #7260ec;
}

.el-button--purple:hover {
  background: #8e80f0 !important;
  border-color: #8e80f0 !important;
  color: #fff !important;
}

.el-button--purple.is-active,
.el-button--purple:active {
  background: #6756d4 !important;
  border-color: #6756d4 !important;
  color: #fff !important;
}

.el-button--purple:active {
  outline: 0;
}

.el-button--purple.is-disabled,
.el-button--purple.is-disabled:active,
.el-button--purple.is-disabled:focus,
.el-button--purple.is-disabled:hover {
  color: #fff !important;
  background-color: #b9b0f6 !important;
  border-color: #b9b0f6 !important;
}

.el-button--purple.is-plain {
  color: #7260ec;
  background: #f1effd;
  border-color: #c7bff7;
}

.el-button--purple.is-plain:focus,
.el-button--purple.is-plain:hover {
  background: #7260ec;
  border-color: #7260ec;
  color: #fff;
}

.el-button--purple.is-plain:active {
  background: #6756d4;
  border-color: #6756d4;
  color: #fff;
  outline: 0;
}

.el-button--purple.is-plain.is-disabled,
.el-button--purple.is-plain.is-disabled:active,
.el-button--purple.is-plain.is-disabled:focus,
.el-button--purple.is-plain.is-disabled:hover {
  color: #aaa0f4;
  background-color: #f1effd;
  border-color: #e3dffb;
}

/* red */

.el-button--red {
  color: #fff;
  background-color: #f5444e;
  border-color: #f5444e;
}

.el-button--red:hover {
  background: #f76971 !important;
  border-color: #f76971 !important;
  color: #fff !important;
}

.el-button--red.is-active,
.el-button--red:active {
  background: #f5444e !important;
  border-color: #f5444e !important;
  color: #fff !important;
}

.el-button--red:active {
  outline: 0;
}

.el-button--red.is-disabled,
.el-button--red.is-disabled:active,
.el-button--red.is-disabled:focus,
.el-button--red.is-disabled:hover {
  color: #fff !important;
  background-color: #faa2a7 !important;
  border-color: #faa2a7 !important;
}

.el-button--red.is-plain {
  color: #f0dbdf;
  background: #fefbfc;
  border-color: #f9f1f2;
}

.el-button--red.is-plain:focus,
.el-button--red.is-plain:hover {
  background: #f0dbdf;
  border-color: #f0dbdf;
  color: #fff;
}

.el-button--red.is-plain:active {
  background: #d8c5c9;
  border-color: #d8c5c9;
  color: #fff;
  outline: 0;
}

.el-button--red.is-plain.is-disabled,
.el-button--red.is-plain.is-disabled:active,
.el-button--red.is-plain.is-disabled:focus,
.el-button--red.is-plain.is-disabled:hover {
  color: #f6e9ec;
  background-color: #fefbfc;
  border-color: #fcf8f9;
}

/* skyblue */
.el-button--skyblue {
  color: #279cfe;
  background-color: #d2eafe;
  border-color: #279cfe;
}

.el-button--skyblue:hover {
  background: #dbeefe !important;
  border-color: #52b0fe !important;
  color: #279cfe !important;
}

.el-button--skyblue.is-active,
.el-button--skyblue:active {
  background: #bdd3e5 !important;
  border-color: #238ce5 !important;
  color: #279cfe !important;
}

.el-button--skyblue:active {
  outline: 0;
}

.el-button--skyblue.is-disabled,
.el-button--skyblue.is-disabled:active,
.el-button--skyblue.is-disabled:focus,
.el-button--skyblue.is-disabled:hover {
  color: #fff !important;
  background-color: #e9f5ff !important;
  border-color: #93ceff !important;
}

.el-button--skyblue.is-plain {
  color: #d2eafe;
  background: #fbfdff;
  border-color: #edf7ff;
}

.el-button--skyblue.is-plain:focus,
.el-button--skyblue.is-plain:hover {
  background: #d2eafe;
  border-color: #d2eafe;
  color: #fff;
}

.el-button--skyblue.is-plain:active {
  background: #bdd3e5;
  border-color: #bdd3e5;
  color: #fff;
  outline: 0;
}

.el-button--skyblue.is-plain.is-disabled,
.el-button--skyblue.is-plain.is-disabled:active,
.el-button--skyblue.is-plain.is-disabled:focus,
.el-button--skyblue.is-plain.is-disabled:hover {
  color: #e4f2fe;
  background-color: #fbfdff;
  border-color: #f6fbff;
}

/* superquery */
.el-button--superquery:focus {
  color: #606266 !important;
  border-color: #dcdfe6 !important;
  background-color: #fff !important;
}
.el-button--superquery:hover {
  color: #228ae1 !important;
  border-color: #bddcf6 !important;
  background-color: #e9f3fc !important;
}

.el-button--superquery:active {
  color: #1f7ccb !important;
  border-color: #1f7ccb !important;
  outline: 0;
}

.el-button--superquery.is-active,
.el-button--superquery.is-plain:active {
  color: #1f7ccb !important;
  border-color: #1f7ccb !important;
}
</style>
